import React from "react";
import { Link } from "react-router-dom";

function User(props) {
  const user = props.user;

  return (
    <div className="card" style={{ width: "20rem" }}>
      <div className="card-body">
        <h4 className="card-title">
          <Link to={`/single/${user.id}`}>
            <p>{user.userName}</p>
          </Link>
        </h4>
        <h6 className="card-subtitle text-muted">{user.email}</h6>
        <p className="card-text">Click on User Name to add task</p>
        <button
          className="btn btn-danger"
          onClick={() => {
            props.startRemovingUser(props.index, user.id);
            props.history.push("/");
          }}
        >
          Remove User
        </button>
        <Link className="btn btn-primary" to={`/single/${user.id}`}>
          Task Count :{" "}
          {props.tasks[user.id] ? props.tasks[user.id].value.length : 0}
        </Link>
      </div>
    </div>

    /*
    <figure className="figure">
      <figcaption>
        <Link to={`/single/${user.id}`}>
          <p>{user.userName}</p>
        </Link>
        <p>{user.email}</p>
      </figcaption>
      <div className="button-container">
        <button
          onClick={() => {
            props.startRemovingUser(props.index, user.id);
            props.history.push("/");
          }}
        >
          Remove
        </button>
        <Link className="button" to={`/single/${user.id}`}>
          <div className="comment-count">
            
            <div>Task Count :</div>
            {props.tasks[user.id] ? props.tasks[user.id].length : 0}
          </div>
        </Link>
      </div>
    </figure>
    */
  );
}

export default User;
